import { useState, useRef } from "react";
import { CurrencyText } from "../../common/CurrencyText";
import BundleDiscountTable from "./common/BundleDiscountTable";
import NewTrainerHeaderItem from "./NewTrainerHeaderItem";
import { getYouTubeEmbedUrl, detectYouTubeVideoId } from "../../../helpers/youtubeHelper"
import { addProductToShoppingCart } from "../../../services/shoppingCartService";
import { ErrorTemplate } from "../../common/ToastMessage/Template";
import { Toast } from "primereact/toast";
const NewTrainerItem = ({
  source,
  onViewMoreClick,
  props,
  bundleDiscounts,
  isActiveDirectDeliveryCoupons,
  onFavoriteClick,
  activeTooltipId,
  onItemHover,
  currentUser,
  lang,
  messages
}) => {
  const isTooltipVisible = activeTooltipId === source.id;
  
  const buyTicket = (bundleDiscount) => {
    if (currentUser) {
      const query = new URLSearchParams({
            isQuickBuy: true,
            productId: source.productId,
            bundleDiscount: bundleDiscount.id,
            quantity: bundleDiscount.numberTicket
          }).toString();
      window.location.href = `/${currentUser.defaultLanguage}/shopping-cart?${query}`;
    } else {
      window.location.href = `/auth/login?lang=${lang}&returnUrl=${window.location.pathname}`;
    }
  };

  const errorToast = useRef(null);
  const showErrorToast = (message) => {
    errorToast.current.show({ 
      severity: "error", 
      detail: message,
      life: 3000, 
      content: (props) => ErrorTemplate(props)
    });
  };

  return (
    <div
      className="flex flex-row flex-nowrap gap-4 w-full"
      onMouseEnter={() => onItemHover && onItemHover(source.id)}
      onMouseLeave={() => onItemHover && onItemHover(null)}
    >
      <Toast ref={errorToast} position="bottom-right" className="keduall-toast"/>
      <div
        className="keduall-trainer-item flex flex-column lg:flex-row gap-4 p-4 flex-1 min-w-0"
      >
        <NewTrainerHeaderItem
          props={props}
          onViewMoreClick={onViewMoreClick}
          onFavoriteClick={onFavoriteClick}
          source={source}
          enableTagsCollapse={false}
          maximumTagItem={3}
        ></NewTrainerHeaderItem>
        <div className="lg:w-15rem xl:w-19rem w-full mx-auto min-w-0">
          <div className="flex flex-column gap-0">
            <BundleDiscountTable
              props={{
                defaultPrice: source.price,
                currencyCode: source.currency,
                ticketUnitLabel: props.ticketUnitLabel,
                couponIcon: props.couponIcon,
              }}
              bundles={bundleDiscounts}
              isActiveDirectDeliveryCoupons={isActiveDirectDeliveryCoupons}

              onSessionClick={buyTicket}
            />
          </div>
        </div>
      </div>
      <div className="keduall-card trainer-card-container hidden lg:block animate__animated animate__zoomIn">
        <div className={`trainer-card-tooltip-${source.id} h-full w-full`}>
          {isTooltipVisible ? (
            <div className="flex relative h-full w-full">
              {source.introductionVideoURL ? (
                <iframe
                  src={getYouTubeEmbedUrl(detectYouTubeVideoId(source.introductionVideoURL))}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="video-frame keduall-card flex card-tooltip"
                  title="source.id"
                ></iframe>
              ) : (
                <div className="video-frame keduall-card flex card-tooltip">
                  <img
                    alt="noUploadVideo"
                    src={props.noUploadVideoImg}
                    className="w-full h-full object-contain"
                  />
                </div>
              )}
            </div>
          ) : (
            <div className="flex"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewTrainerItem;